import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { ModalController } from '@ionic/angular';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms'; 
import { LoadingService } from 'src/app/services/loading.service';


@Component({
  selector: 'app-register-aswholeseller',
  templateUrl: './register-aswholeseller.page.html',
  styleUrls: ['./register-aswholeseller.page.scss'],
})
export class RegisterAswholesellerPage implements OnInit {

  registerAsWholesaler:any;
  ionicForm: FormGroup;
  GSTurl:any
  multipleImages:any=[]
  PANurl:any
  bannerimage:any
  submitted = false;
  constructor(private userService : UserService, public modalController: ModalController,public formBuilder: FormBuilder,public loadingService:LoadingService) {

    this.ionicForm = this.formBuilder.group({
      gstNumber:['',[Validators.pattern('^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$')]],
      companyName:['', [Validators.required, ]],
      panNumber:['', [Validators.required,Validators.pattern('^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$') ]],
      phone:['', [Validators.required,Validators.pattern(  '[6-9]\\d{9}' ) ]],
      // imageInput: ['', Validators.required]
     })
   }

  ngOnInit() {
  }

  uploadPANImage(event) { 
    console.log(event,"My GST image upload data")

this.loadingService.presentLoading("Please wait")
    this.userService.uploadImage(event).then(url => {
      this.loadingService.dismiss()
      this.GSTurl = url;

      console.log("GST Image Upload",this.GSTurl)

      this.multipleImages.push(url)
console.log("Multiple image data",  this.multipleImages)
      // this.bannerimage = url

    })

  }
  uploadGSTImage(event) { 
    console.log(event,"My PAN image upload data")
    this.loadingService.presentLoading("Please wait")
    this.userService.uploadImage(event).then(url => {
      this.loadingService.dismiss()

      this.PANurl = url;

      console.log("PAN Image Upload",this.PANurl)

      //this.multipleImages.push(url)

      // this.bannerimage = url

    })

  }

  Submit(){
     this.submitted = true;
    // if (this.ionicForm.invalid) {
    //     return;
    // }else{

    // display form values on success
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.ionicForm.value, null, 4));

     if (this.ionicForm.valid) {
      let formData={
        "phone":this.ionicForm.value.phone,
        "gstNumber":this.ionicForm.value.gstNumber,
        "companyName":this.ionicForm.value.companyName,
        "gstPath":this.multipleImages,
        "panCard":this.ionicForm.value.panNumber,
      }
      console.log("Form Data",this.ionicForm.value )
      this.userService.registerAsWholseller(formData).subscribe((res: any) => {
        this.registerAsWholesaler=res;
        console.log("Form Data",this.registerAsWholesaler)
  })
}else{
  alert("Please enter Valid field")
}
   
    //}

    
  
}
get f() { return this.ionicForm.controls; }
  async closeModel() {
    const close: string = "Modal Removed";
    await this.modalController.dismiss(close);
  }

}
